import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext'
import { readCreditHistory } from './creditHistoryApi'
import CreditHistoryTable from './CreditHistoryTable'
import { createNadDebug } from '../../utils/debugLog'

const log = createNadDebug('dw:billing-history')
const knownKinds = new Set(['welcome_bonus', 'daily_claim', 'charge', 'refund', 'topup', 'purchase', 'purchase_refund', 'operator_topup', 'operator_deduct'])

export default function CreditHistory() {
  const { t } = useTranslation('settings')
  const { user } = useAuth()
  const history = useQuery({
    queryKey: ['billing', 'credit-history', user?.id],
    queryFn: async ({ signal }) => {
      const rows = await readCreditHistory(signal)
      log({ event: 'history:loaded', trace_id: 'billing:history', row_count: rows.length })
      return rows
    },
    enabled: user !== null,
    staleTime: 30_000,
  })
  return <section className="flex flex-col gap-3" aria-labelledby="billing-history-title" data-testid="billing-history">
    <div>
      <h4 id="billing-history-title" className="text-lg font-semibold text-foreground">{t('settingsModal.billing.historyTitle')}</h4>
      <p className="mt-1 text-base text-muted-foreground">{t('settingsModal.billing.historyDescription')}</p>
    </div>
    {history.isPending ? <p role="status" className="text-base text-muted-foreground">{t('settingsModal.billing.historyLoading')}</p>
      : history.isError ? <p role="alert" className="text-base text-destructive">{t('settingsModal.billing.historyError')}</p>
      : history.data.length === 0 ? <p className="py-2 text-base text-muted-foreground" data-testid="billing-history-empty">{t('settingsModal.billing.historyEmpty')}</p>
      : <>
        <CreditHistoryTable rows={history.data.map(row => ({
          id: row.id,
          createdAt: row.createdAt,
          action: knownKinds.has(row.type) ? t(`settingsModal.billing.historyKind.${row.type}`) : row.type,
          credits: row.credits,
          balanceAfter: row.balanceAfter,
        }))} />
        <p className="text-sm text-muted-foreground">{t('settingsModal.billing.historyFootnote')}</p>
      </>}
  </section>
}
